import React from "react";
import { Link } from "react-router-dom";
import Newsletter from "../../Components/Newsletter/Newsletter";
// import "./section.css";

export default function Homepage() {
  return (
    <>
      <div
        className=" w-full h-screen bg-no-repeat bg-cover  md:w-32 lg:w-48	"
        Style="background-image: url('./image/homepage.gif')"
      >
        <div className="text-center fs-5 pt-60 text-neutral-50">
          <h4 className="font-semibold text-[#EE2DA4]">One-Stop Cloud Ecosystem</h4>
          <h1 className="text-4xl pt-2 px-2 font-semibold">
            Remote Development, Right at Your Fingertips
          </h1>
          <p className="mt-3 px-2">
            Discover what our on-demand cloud development teams can do for your bottom line today.
          </p>

          <Link to="/contact">
            <button className="btn btn-success uppercase text-white duration-600 px-4 mt-4  mx-2 border-0 rounded-none bg-[#ee2da4] text-sm font-bold">Get Started </button></Link>

        </div>

      </div>
      <div
        className=" w-full h-auto section2"
      >
        <div className="text-center pt-80 w-100 text-neutral-50 h-screen bg-no-repeat bg-cover	"
          Style="background-image: url('./image/home2.gif')">

        </div>
        <div className="text-center  pt-44 w-100 text-[#000]"
        > <span className="text-[#ee2da4] text-sm font-bold">MsCube Tech</span>
          <h1 className="text-3xl  font-semibold">Virtual Teams, Real Results</h1>

          <p className="600px:px-2 px-6 py-2">
            From front-end and back-end developers to UI/UX designers, MsCube Tech makes it easy to remotely access the dedicated, world-class development teams your organization needs to move forward.
          </p>
          <Link to="/about">
            <button className="btn btn-success uppercase text-white duration-600 mt-3 mb-8 mx-2 border-0 rounded-none bg-[#ee2da4] text-sm font-bold px-4">Read More </button></Link>

        </div>
      </div>
      <div
        className=" w-full h-auto  bg-no-repeat bg-cover bg-fixed	"
        Style="background-image: url('./image/h1.gif')"
      >
        <h1 className=" text-[#ffff] text-center pt-20 font-bold text-3xl" id="our">OUR  <span className="text-[#ee2da4]">SOLUTIONS</span></h1>
        <h5 className="px-10 py-1 text-[#fff] justify-center text-center">You've got visionary ideas. We've got access to elite tech talent with the capabilities to bring those ideas to life.MsCube tech provides businesses like yours with on-demand remote tech teams that actually get results.</h5>
        <div className="section2 py-4 relative justify-center ">

          <div class="card m-2 px-2 " Style="width: 22rem;">
            <Link to="/Fullstack-web-development">  <img src="./image/full-stack-development.gif" class="h-52 p-0 m-0 card-img-top" alt="..." /> </Link>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl">Full Stack Development</h5>

              <p class="card-text pb-2">Full-stack developers need to have a good understanding of both front-end, back-end..Front end, Proficient in HTML, CSS, and JavaScript and back end, Proficient in server-side languages like PHP, MongoDB Express, and Node Js.</p>
              <Link to="/Fullstack-web-development" class=" font-bold  text-[#ee2da4]  ">
                VIEW WORK</Link>
            </div>

          </div>



          <div class="card m-2 px-2 " Style="width: 22rem; ">
            <Link to="/App-development"> <img src="./image/app.gif" class="p-0 m-0 h-52 card-img-top" alt="..." /></Link>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl">App Development</h5>
              <p class="card-text pb-2">Successful mobile applications start with a winning mobile development infrastructure. MsCube Tech gives you the talent required to quickly create monetizable apps that engage and entertain your users.</p>
              <Link to="/App-development" class=" font-bold  text-[#ee2da4]  ">VIEW WORK</Link>
            </div>
          </div>

          <div class="card m-2 px-2 " Style="width: 22rem;">
            <Link to="/product-design" ><img src="./image/ui.gif" class="h-52 p-0 m-0 card-img-top" alt="..." /></Link>
            <div class="card-body ">
              <h5 class="card-title font-bold text-2xl ">UI/UX Design</h5>
              <p class="card-text pb-2">UI/UX design is essential to the success of your projects. Don’t have the time or resources to handle things internally? No problem – with MsCube Tech, expert UI/UX teams are literally just minutes away.</p>
              <Link to="/UI-UX-development" class=" font-bold  text-[#ee2da4]  ">VIEW WORK</Link>
            </div>
          </div>
        </div>
      </div>
      <div
        className=" w-full justify-center text-[#ffff] h-auto py-6 bg-no-repeat bg-cover bg-fixed	pt-10 text-center "
        Style="background-image: url('./image/main33.jpg')"
      >
        <div className="px-8 m-2">
          <h1 className="text-2xl pt-16 font-bold uppercase">Scale Smarter With MsCube<span className="text-[#ee2da4]"> Tech</span>
          </h1>
          <p className="px-4 py-1 " > Backed by state-of-the-art web development and design teams, our <strong>Cloud Memberships</strong>
            were specifically designed to enable organizations like yours to scale quicker. Check out the link below to explore what’s possible.
          </p>
        </div>
        <div className="px-4  smart py-1 section2  justify-center">
          <div class="card pt-4 mx-1 m-1 text-[#000]" Style="width: 18rem;">
            <img src="./image/interview.svg" class=" card-img-top text-[#ee2da4] p-0 mx-24  " Style="width: 6rem;" alt="..." />
            <div class="card-body">
              <h5 class="card-title font-bold  fs-5">Interview Coordinators by Phone</h5>
              <p class="card-text">We’re remote but we’re real people! Give our team a call anytime</p>
            </div>
          </div>

          <div class="card pt-4 mx-1 m-1 text-[#000]" Style="width: 18rem;">
            <img src="./image/access.svg" class=" card-img-top text-[#ee2da4] mx-20 " Style="width: 6rem;" alt="..." />
            <div class="card-body">
              <h5 class="card-title font-bold  text-xl">Access Qualified HR Support</h5>
              <p class="card-text">MsCube Tech is backed by HR pros and a pool of skilled on-call developers.</p>
            </div>
          </div>

          <div class="card pt-4 mx-1 m-1 text-[#000]" Style="width: 18rem;">
            <img src="./image/additional-resources.svg" class=" card-img-top text-[#ee2da4] mx-24 " alt="..." Style="width: 4rem;" />
            <div class="card-body">
              <h5 class="card-title font-bold  text-xl">Save BIG on Additional Resources</h5>
              <p class="card-text">Adding extra members to your team can drop the hourly rate up to 30%.</p>
            </div>
          </div>
        </div>
        <div className="px-4 smart section2 justify-center">
          <div class="card pt-4 mx-1 m-1 text-[#000]" Style="width: 18rem;">
            <img src="./image/development.svg" class=" card-img-top text-[#ee2da4] mx-28 " Style="width: 4rem;" alt="..." />
            <div class="card-body">
              <h5 class="card-title font-bold  fs-5">Design and Front-End Development</h5>
              <p class="card-text">Unlock and design 60/hrs of front-end development each month.</p>
            </div>
          </div>

          <div class="card pt-4 mx-1 m-1 text-[#000]" Style="width: 18rem;">
            <img src="./image/develop-ai.svg" class=" card-img-top text-[#ee2da4] mx-20" Style="width: 6rem;" alt="..." />
            <div class="card-body">
              <h5 class="card-title font-bold  fs-5">Deploy Innovative Technology</h5>
              <p class="card-text">Get expert help with blockchain, NFT, and AI development.</p>
            </div>
          </div>
          <div class="card pt-4 mx-1 m-1 text-[#000]" Style="width: 18rem;">
            <img src="./image/enterprise-membership.svg" class=" card-img-top text-[#ee2da4] mx-20 " alt="..." Style="width: 4rem;" />
            <div class="card-body">
              <h5 class="card-title p-0 m-0 font-bold  fs-5">Maintain Ownership of Your IP</h5>
              <p class="card-text">Work done by Dev teams remains the sole property of your company.</p>
            </div>
          </div>
        </div>
      </div>
      <Newsletter />
      <div className="section2 justify-center h-auto mt-24 text-[#ffff] bg-[#6a6dec] ">
            <h1 className=" pt-10 px-10 text-white text-2xl">Buil great products with App development service.!</h1>
            <Link to="/contact">
              <button className="border-0 rounded-none btn btn-success font-bold text-white my-10 mx-10 px-4 py-2 bg-[#ce2e90]">Get Started</button>
            </Link>

          </div>
    </>
  );
}
